import { createSelector } from "reselect";

const selectSearch = (state) => state.get("searchReducer");
const selectGlobal = (state) => state.get("globalReducer");
const selectHome = (state) => state.get("homeReducer");
const selectStory = (state) => state.get("storyReducer");

// ================
// SEARCH
// ================
const selectSearchTerm = () =>
    createSelector(selectSearch, (searchState) =>
        searchState.get("searchTerm")
    );

const selectSearchResult = () =>
    createSelector(selectSearch, (searchState) =>
        searchState.get("searchResult")
    );

const selectLocations = () =>
    createSelector(selectSearch, (searchState) => searchState.get("locations"));

const selectChurchesNear = () =>
    createSelector(selectSearch, (searchState) =>
        searchState.get("churchesNear")
    );

const selectLocation = () =>
    createSelector(selectSearch, (searchState) => searchState.get("location"));

const selectUserLocation = () =>
    createSelector(selectSearch, (searchState) =>
        searchState.get("userLocation")
    );

const selectFilterItems = () =>
    createSelector(selectSearch, (searchState) =>
        searchState.get("filterItems")
    );

const selectFilters = () =>
    createSelector(selectSearch, (searchState) => searchState.get("filters"));

const selectMunicipalities = () =>
    createSelector(selectSearch, (searchState) =>
        searchState.get("municipalities")
    );

const selectChurches = () =>
    createSelector(selectSearch, (searchState) => searchState.get("churches"));

const selectNextPage = () =>
    createSelector(selectSearch, (searchState) => searchState.get("nextPage"));

const selectTotalAvailable = () =>
    createSelector(selectSearch, (searchState) =>
        searchState.get("totalAvailable")
    );

const selectFetchStatus = () =>
    createSelector(selectSearch, (searchState) =>
        searchState.get("fetchAgain")
    );

const selectLatestFetchType = () =>
    createSelector(selectSearch, (searchState) =>
        searchState.get("latestFetchType")
    );

const selectSearchError = () =>
    createSelector(selectSearch, (searchState) =>
        searchState.get("searchErrorMsg")
    );

// ================
// GLOBAL
// ================
const selectEraContent = () =>
    createSelector(selectGlobal, (globalState) => globalState.get("era"));

// ================
// HOME
// ================
const selectHomepageLoaded = () =>
    createSelector(selectHome, (homeState) => homeState.get("loaded"));
const selectFooterPages = () =>
    createSelector(selectHome, (homeState) => homeState.get("footerPages"));
const selectEraChurches = () =>
    createSelector(selectHome, (homeState) => homeState.get("eraChurches"));
const selectedStories = () =>
    createSelector(selectHome, (homeState) => homeState.get("selectedStories"));
const selectNewsBox = () =>
    createSelector(selectHome, (homeState) => homeState.get("newsBox"));

// ================
// STORIES
// ================
const selectStoryTags = () =>
    createSelector(selectStory, (storyState) => storyState.get("storyTags"));

const selectTagsFilter = () =>
    createSelector(selectStory, (storyState) => storyState.get("tagsFilter"));

export {
    selectSearchTerm,
    selectSearchResult,
    selectLocations,
    selectChurchesNear,
    selectUserLocation,
    selectLocation,
    selectFilterItems,
    selectEraContent,
    selectFilters,
    selectMunicipalities,
    selectChurches,
    selectNextPage,
    selectTotalAvailable,
    selectFetchStatus,
    selectStoryTags,
    selectTagsFilter,
    selectLatestFetchType,
    selectSearchError,
    selectFooterPages,
    selectEraChurches,
    selectedStories,
    selectNewsBox,
    selectHomepageLoaded,
};



// WEBPACK FOOTER //
// ./src/selectors.js